module.exports = __webpack_public_path__ + "img/bus-station-green.c9abea4b.svg";